import "./index.less"
class Slideshow {
    constructor(el, params) {
        this.DOM = {
            el: el
        };
        this.config = {
            slideshow: {
                delay: 1000 * params.speed,
                pagination: {
                    duration: params.speed,
                }
            }
        };
        this.params = params
        this.init();
    }
    init() {
        var self = this;
        this.slideshow = new Swiper(this.DOM.el, {
            loop: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1
            },
            observer: true,
            autoplay: self.params.autoplay ? {
                delay: this.config.slideshow.delay,
                disableOnInteraction: false,
            } : false,
            speed: 600,
            preloadImages: true,
            updateOnImagesReady: true,
            pagination: {
                el: '.slideshow-pagination',
                clickable: true,
                bulletClass: 'slideshow-pagination-item',
                bulletActiveClass: 'active pagination-active',
                clickableClass: 'slideshow-pagination-clickable',
                modifierClass: 'slideshow-pagination-',
                renderBullet: function (index, className) {
                    var slideIndex = index,
                        number = (index <= 8) ? '0' + (slideIndex + 1) : (slideIndex + 1);
                    var slidesNums = this.slides.length;
                    if(slidesNums > 3){
                        var paginationItem = '<span class="slideshow-pagination-item">';
                        paginationItem = (index <= 8) ? paginationItem +
                          '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
                          paginationItem;
                        paginationItem += '</span>';
                        return paginationItem;
                    }else{
                        return ''
                    }
                },
            },
            effect: "fade",
            navigation: {
                nextEl: '.slideshow-navigation-button.next',
                prevEl: '.slideshow-navigation-button.prev',
            },
            on: {
                init: function () {
                    self.animate('next');
                },
                transitionEnd: function() {
                  let index = this.activeIndex;
                },
            }
        });

        this.initEvents();
    }
    initEvents() {
        this.slideshow.on('paginationUpdate', (swiper, paginationEl) => setTimeout(() => {
            this.animatePagination(swiper, paginationEl)
        }, 100));
        this.slideshow.on('slideNextTransitionStart', () => this.animate('next'));
        this.slideshow.on('slidePrevTransitionStart', () => this.animate('prev'));
        setTimeout(() => {
            this.animatePagination(null)
        }, 200);

        const self = this;
        $(".slide-swiper .btn-link,.slide-swiper .btn-view-more").click(function(e) {
            e.preventDefault();
            e.stopPropagation();

            const link = $(this).attr("data-link")
            const open_new = $(this).attr("data-new") == "true";

            // GA统计
            const type = $(this).data('type');
            let btnName;
            let itemTitle;
            if (type === 'btn-view-more') {
                itemTitle = $(this).data('analytics-title').trim().replaceAll('\n', ' ') || 'single_pic';
                btnName = $(this).text().trim();
            } else {
                itemTitle = $(this).find('.slide-title').text().trim().replaceAll('\n', ' ') || 'single_pic';
            }
            const itemIndex = $(this).data('index');
            const params = {
                module: itemTitle,
                position: itemIndex
            }

            if (btnName) {
                params.button_name = btnName;
            }
            if (link) {
                params.link = link;
                self.GAEvent(params);

                if (open_new) {
                    window.open(link, '_blank');
                } else {
                    window.location.href = link;
                }
            } else {
                self.GAEvent(params);
            }
        })
    }
    animate(direction = 'next') {
        this.DOM.activeSlide = this.DOM.el.querySelector('.swiper-slide-active'),
            this.DOM.activeSlideImg = this.DOM.activeSlide.querySelector('.slide-image'),
            this.DOM.activeSlideTitle = this.DOM.activeSlide.querySelector('.slide-content'),
            this.DOM.activeSlideTitleLetters = this.DOM.activeSlideTitle.querySelectorAll('span');

        this.DOM.activeSlideTitleLetters = direction === "next" ? this.DOM.activeSlideTitleLetters : []
            .slice.call(this.DOM.activeSlideTitleLetters).reverse();

        this.DOM.oldSlide = direction === "next" ? this.DOM.el.querySelector('.swiper-slide-prev') : this
            .DOM.el.querySelector('.swiper-slide-next');
        if (this.DOM.oldSlide) {
            this.DOM.oldSlideTitle = this.DOM.oldSlide.querySelector('.slide-content')
        }
    }
    animatePagination(swiper, paginationEl) { // 分页动画
        const DOC = paginationEl || document
        this.DOM.paginationItemsLoader = DOC.querySelectorAll('.pagination-separator-loader');
        this.DOM.activePaginationItem = DOC.querySelector('.pagination-active');
        this.DOM.activePaginationItemLoader = this.DOM.activePaginationItem?.querySelector('.pagination-separator-loader');

        $(this.DOM.paginationItemsLoader).width("0px")
        $(this.DOM.activePaginationItemLoader).animate({width: "100%"}, this.config.slideshow.pagination.duration * 1000, "linear");
    }

    /**
     * @description GTM事件处理
     * @param {*} params 参数传递
     */
    GAEvent(params) {
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
            event: "ga4Event",
            event_name: "home_page_banner",
            event_parameters: {
                current_page: window.location.href, // current page url
                ...params
            }
        });
    }
}
export default Slideshow
